import {
  Poll,
  PollFromServer,
  QK,
  translateTargetGroupNicely,
} from 'ck-queries';
import { fetchWithErrorThrowing, standardDateFormat } from 'ck-utils';

import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';

// Query hook
export const usePollsDraft = () =>
  useQuery({
    queryKey: QK.polls.draft,
    queryFn: getPollsDraft,
  });

// Query function
export async function getPollsDraft(): Promise<Poll[]> {
  const res = await fetchWithErrorThrowing('/polls/draft', {
    method: 'GET',
  });

  const data: { polls: PollFromServer[] } = await res.json();

  const polls: Poll[] = data.polls.map((m) => {
    return {
      ...m,
      scheduleTime: dayjs(m.scheduleTime).format(standardDateFormat),
      sent: m.sent ? dayjs(m.sent).format(standardDateFormat) : undefined,
      targetGroupString: translateTargetGroupNicely(m.targetGroup),
      openedByString: `${m.openedByCount} av ${m.targetGroup.count}`,
    };
  });

  return polls;
}
